import { KeyOf } from './object';

export function toArray<T>(obj: { [s: string]: T } | { [n: number]: T }): T[];
export function toArray<T extends {}>(obj: T): KeyOf<T>[] {
  return Object.keys(obj).map(key => (obj as any)[key] as KeyOf<T>);
}
